import React from 'react'
import { DateRange, dateRangeToQuery, dateRangeFromQuery } from 'dateRanges'
import { useNavigation } from 'hocs'
import DateRangePicker from 'uiComponents/popups/comparisonDateRangePicker'
import { DateRangeType } from 'uiComponents/popups/comparisonDateRangePicker/schema'
import { faCaretDown as IconDown, faCaretUp as IconUp } from '@fortawesome/free-solid-svg-icons'
import { SingleSelect } from 'uiComponents/input'
import { ORDERS_DEFAULT_DATE_RANGE } from 'orders/orders/utils'
import { useTranslation } from 'translations'
import './ordersDateFilter.scss'

const OrdersDateFilter: React.FC = () => {
    const { t } = useTranslation()
    const dateRangeTypeOptions = [
        { name: t('orders.orders.filters.dateType.bookings'), value: 'sale' },
        { name: t('orders.orders.filters.dateType.visits'), value: 'visit' },
    ]
    const navigation = useNavigation()
    const query = navigation.query()

    const onDateRangeChanged = (range: DateRange) => {
        navigation.addQueryWithReplace({ ...dateRangeToQuery(range), page: '1' })
    }

    const onDateRangeTypeChanged = (rangeType: DateRangeType) => {
        navigation.addQueryWithReplace({ dateRangeType: rangeType, page: '1' })
    }

    const dateRange = dateRangeFromQuery(query, ORDERS_DEFAULT_DATE_RANGE)
    const dateRangeType = query.dateRangeType === 'visit' ? 'visit' : 'sale'

    return (
        <div className="orders-date-filter">
            <SingleSelect
                id="orders-daterange"
                options={dateRangeTypeOptions}
                selected={dateRangeType}
                noSelectOption={dateRangeType}
                onSelect={onDateRangeTypeChanged}
                customIconDown={IconDown}
                customIconUp={IconUp}
                height="2rem"
            />
            <div id="orders-filter">
                <DateRangePicker range={dateRange} onChange={onDateRangeChanged} allowFutureDateSelection />
            </div>
        </div>
    )
}

export default OrdersDateFilter
